import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getLatestResultOfHorsesWithOwner = createSlice({
    name: 'LatestResultOfHorsesWithOwner',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchLatestResultOfHorsesWithOwner.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchLatestResultOfHorsesWithOwner.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchLatestResultOfHorsesWithOwner.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    }
});

export const { setOwner, setStatus } = getLatestResultOfHorsesWithOwner.actions;
export default getLatestResultOfHorsesWithOwner.reducer;

export const fetchLatestResultOfHorsesWithOwner = createAsyncThunk('/LatestResultOfHorsesWithOwner/fetch', async ({ year, id } = {}) => {
    const cleanId = id?._id || id?.id || (typeof id === 'string' ? id : "");
    if (!cleanId) return [];
    const query = (year !== undefined && year !== null && year !== "") ? `?year=${year}&size=400` : `?year=&size=400`;
    const res = await axios.get(`${getBaseUrl()}/LatestResultOfHorsesWithOwner/${cleanId}${query}`);
    const OwnerData = res.data;
    return OwnerData.data || [];
});
